/**
 * Created by Ning Jiang on 3/20/2017.
 */

import {ParsedInitData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedInitData";
import {TombstoneGameMode} from "../../gamemode/TombstoneGameMode";
import {TombstoneServerDataParser} from "../TombstoneServerDataParser";
import {ITombstoneParsedServerData} from "./ITombstoneParsedServerData";
import {ITombstoneInitData} from "./ITombstoneServerData";
import {TombstoneNoMercy} from "../../TombstoneNoMercy";
import {APIEvent} from "@nolimitcity/slot-launcher/bin/interfaces/APIEventSystem";
import {APIFeatureBetEventData} from "@nolimitcity/slot-launcher/bin/interfaces/APIBetEventData";
import {Logger} from "@nolimitcity/slot-launcher/bin/utils/Logger";
import {TombstoneGameModuleConfig} from "../../TombstoneGameModuleConfig";

export class TombstoneParsedInitData extends ParsedInitData implements ITombstoneParsedServerData {

    private readonly _superFreespinTriggeredThisSpin:boolean;
    public get superFreespinTriggeredThisSpin():boolean {
        return this._superFreespinTriggeredThisSpin;
    }

    private readonly _multiplierOnReel:number[];
    public get multiplierOnReel():number[] {
        return this._multiplierOnReel;
    }

    private readonly _overlayWildsBeforeSpin:boolean[][];
    public get overlayWildsBeforeSpin():boolean[][] {
        return this._overlayWildsBeforeSpin;
    }

    private readonly _bonusSpinsLeft:number;

    public enhancedBet:boolean;
    public nextPlayerInteraction:any;

    public featureBuyTimesBetValue:any;
    public isRestoreFeatureBet:boolean;
    public buyFeatureName:string;
    private asBuyFeatureName:string;

    private wasFeatureBuy:boolean;
    private playedBetValue:number;
    private boostedBet:boolean;
    public accumulatedRoundWin:number;



    public get bonusSpinsLeft():number {
        return this._bonusSpinsLeft;
    }

    constructor(rawData:ITombstoneInitData, dataParser:TombstoneServerDataParser) {
        super(rawData, dataParser);

        this._superFreespinTriggeredThisSpin = dataParser.parseSuperFreespinTriggeredThisSpin(rawData);
        this._multiplierOnReel = dataParser.parseMultiplierOnReel(rawData);
        this._overlayWildsBeforeSpin = dataParser.parseOverlayWildsBeforeSpin(rawData);
        this._bonusSpinsLeft = dataParser.parseBonusSpinsLeft(rawData);


        this.wasFeatureBuy = rawData.wasFeatureBuy;
        this.playedBetValue = rawData.playedBetValue;
        this.boostedBet = rawData.boostedBet;
        this.accumulatedRoundWin = Number(rawData.accumulatedRoundWin);


        if(rawData.featureBuyTimesBetValue != undefined) {
            this.featureBuyTimesBetValue = rawData.featureBuyTimesBetValue;
        }


        TombstoneNoMercy.api.events.on(APIEvent.BET, (betData:APIFeatureBetEventData) => {
            if(this.featureBuyTimesBetValue) {
                for (let index = 0; index < this.featureBuyTimesBetValue.length; index++) {
                    if (this.featureBuyTimesBetValue[index].name === betData.featureName) {
                        this.buyFeatureName = betData.featureName;
                        Logger.logDev("Opted Feature : ", this.buyFeatureName);
                        break;
                    }
                }
            }
        });

        TombstoneNoMercy.api.events.on(APIEvent.ACTION_SPINS_BET, (betData:any) => {
            if(betData.type &&  betData.type === "featureBet") {
                this.asBuyFeatureName = betData.featureName;
                //console.log("Opted Feature Action Spin Data:", betData);
                //console.log("Opted Feature Action Spin: ", this.asBuyFeatureName);
            }
        });

        TombstoneNoMercy.api.events.once("featureBet", (data:boolean) => {
            this.isRestoreFeatureBet = data;
        });

        if(this.isRestoreFeatureBet) {
            if(rawData.mode === "FREESPIN" || rawData.mode === "SUPER_FREESPIN" || (rawData.mode === "RESPIN" || rawData.nextMode === "RESPIN")) {
                this.buyFeatureName = rawData.mode;
            }
        }

    }

    public getBetPrice(): number {
        const betLevel: string = TombstoneNoMercy.api.freeBets.hasFreeBets() ? TombstoneNoMercy.api.freeBets.getBet() : TombstoneNoMercy.api.betLevel.getLevel();
        let price: number = this?.playedBetValue || parseFloat(betLevel);
        if (this.wasFeatureBuy || this.boostedBet) {
            for (let index = 0; index < this.featureBuyTimesBetValue.length; index++) {
                if (this.featureBuyTimesBetValue[index].name === this.buyFeatureName) {
                    price *= this.featureBuyTimesBetValue[index].price;
                    break;
                }
            }
        }
        return price;
    }

    public isWinBelowStake(): boolean {
        return TombstoneNoMercy.api.gameClientConfiguration.belowStakeWinRestriction && (this.accumulatedRoundWin <= this.getBetPrice());
    }

    public getAccumulatedRoundWin(): number {
        return this.accumulatedRoundWin;
    }

    private getBasePlayedBetValue():number {
        let betLevel = TombstoneNoMercy.api.freeBets.hasFreeBets() ? TombstoneNoMercy.api.freeBets.getBet() : TombstoneNoMercy.api.betLevel.getLevel();
        return this?.playedBetValue || parseFloat(betLevel);
    }

    public getBuyFeaturePrice():number {
        let price = this.getBasePlayedBetValue();

        for(let index = 0; index < TombstoneGameModuleConfig.initData.featureBuyTimesBetValue.length; index++) {
            if(this.featureBuyTimesBetValue[index].name === this.asBuyFeatureName) {
                price *= this.featureBuyTimesBetValue[index].price;
                break;
            }
        }

        return price;
    }

    protected isFeatureTotalWin():boolean {
        return this.superFreespinTriggeredThisSpin || this.mode === TombstoneGameMode.SUPER_FREESPIN;
    }

    protected isNextFeatureTotalWin():boolean {
        return this.nextMode === TombstoneGameMode.SUPER_FREESPIN;
    }
}